export interface ConfigDetails {
  descriptionKey: string;
  value: string | null;
}

export type ConfigKeys =
  | 'daysToDisableAccount'
  | 'daysToLockInactivityAccount'
  | 'daysToEmailAdmin'
  | 'daysToInvalidateLink'
  | 'timesOfMaxLogin'
  | 'minutesOfSessionTimeout'
  | 'minutesOfSessionTimeoutPrivilegedAdmin'
  | 'minutesOfSessionTimeoutNonPriviledgeAdmin'
  | 'daysOfPaymentLinkExpire'
  | 'daysOfAccessLinkExpire'
  | 'timesOfMaxFailedAttempt'
  | 'secondToWaitLogin'
  | 'lastUpdatedBy'
  | 'lastUpdatedOn'
  | 'transactionLogUuid';

export type Configs = {
  [key in ConfigKeys]: ConfigDetails;
};

export const configNameDic = {
  daysToDisableAccount: 'days-to-disable-account-after-result-release',
  daysToLockInactivityAccount: 'days-to-lock-inactivity-account',
  daysToEmailAdmin: 'days-to-email-admin-to-view-after-account-disabled',
  daysToInvalidateLink: 'days-to-invalidate-result-release-link-after-generating',
  timesOfMaxLogin: 'times-of-max-login-try',
  minutesOfSessionTimeout: 'minutes-of-inactivity-before-session-timeout',
  minutesOfSessionTimeoutPrivilegedAdmin:
    'minutes-of-inactivity-before-session-timeout-privileged-admin',
  minutesOfSessionTimeoutNonPriviledgeAdmin:
    'minutes-of-inactivity-before-session-timeout-non-privileged-admin',
  daysOfPaymentLinkExpire: 'days-before-payment-unique-link-expire',
  daysOfAccessLinkExpire: 'days-before-access-link-expire',
  timesOfMaxFailedAttempt: 'times-of-max-failed-attempt',
  secondToWaitLogin: 'max-seconds-to-wait-to-retry-login',
};
